import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';
import { TourEventsFormValues } from '@/ui/pages/app/project/tour/ontour/travels-and-dates/components/tour-event-form-values/TourEventsFormValues';

import { convertCsvToTourEventsFormValues } from '../utils/import-csv/convert-csv-to-tour-events-form-values';

type Params = {
  text: string;
};

type Result = TourEventsFormValues;

export const importTourEventsFromCsv = createAppAsyncThunk(
  'projectTourOntour/importTourEventsFromCsv',
  async (params: Params, { extra: { snackbarGateway } }): Promise<Result> => {
    let formValues: TourEventsFormValues;
    try {
      formValues = await convertCsvToTourEventsFormValues(params.text);
    } catch (error) {
      showSnackbarError(snackbarGateway, error);
      throw error;
    }
    return formValues;
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway, error: unknown) {
  const message = `${translate('ImportTourEventsFromCsv.Message.error')} ${String(error)}`;
  snackbarGateway.error(message);
}
